import React, { PureComponent } from 'react'
import { Header, Icon } from 'semantic-ui-react';
import TextLoop from 'react-text-loop';

import './status.css';

class Status extends PureComponent {
  render() {
    const visible = this.props.show ? 'show' : 'hide';
    return (
      <div className={"status-animate " + visible}>
        <div className="status-container">
          <Header as='h2' icon>
            <Icon name={this.props.icon} />
            {this.props.title}
            <Header.Subheader>
              {this.props.subtitle}
            </Header.Subheader>
          </Header>
        </div>
      </div>
    );
  }
}

export default Status


// WEBPACK FOOTER //
// ./src/components/status/index.js